/// CSS — Tailwind utilities
import '../css/app.css';

/// SCSS — custom homepage styles
import '../sass/app.scss';

/// Vue + Components
import { createApp } from 'vue';
import SweetAlert from './shared/components/SweetAlert.vue';

const app = createApp({});
app.component('sweet', SweetAlert);
app.mount('#app');

// ============================================================
// Matrix rain canvas
// ============================================================

(function () {
    const canvas = document.getElementById('matrix-canvas');
    const ctx = canvas.getContext('2d');
    const chars = '01アイウエオカキクケコ{}[]()<>/\\|=+-_~ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    let W, H, cols, drops;

    function resize() {
        W = canvas.width = window.innerWidth;
        H = canvas.height = window.innerHeight;
        cols = Math.floor(W / 18);
        drops = Array(cols).fill(1);
    }

    window.addEventListener('resize', resize);
    resize();

    function draw() {
        ctx.fillStyle = 'rgba(6,10,6,0.05)';
        ctx.fillRect(0, 0, W, H);
        ctx.font = '13px "JetBrains Mono",monospace';

        for (let i = 0; i < drops.length; i++) {
            const char = chars[Math.floor(Math.random() * chars.length)];
            const b = Math.random();

            if (b > 0.97) {
                ctx.fillStyle = '#ffffff';
            } else if (b > 0.85) {
                ctx.fillStyle = '#00e676';
            } else {
                ctx.fillStyle = `rgba(0,${Math.floor(100 + b * 130)},60,0.6)`;
            }

            ctx.fillText(char, i * 18, drops[i] * 18);

            if (drops[i] * 18 > H && Math.random() > 0.975) {
                drops[i] = 0;
            }

            drops[i]++;
        }
    }

    setInterval(draw, 50);
})();

// ============================================================
// Scroll-reveal: .fade → .fade.in
// ============================================================

const revealObs = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
        if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add('in'), i * 60);
            revealObs.unobserve(e.target);
        }
    });
}, { threshold: 0.1 });

document.querySelectorAll('.fade').forEach(el => revealObs.observe(el));

// ============================================================
// Skill bars: .bar-fill → .bar-fill.go on viewport entry
// ============================================================

const barObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            e.target.querySelectorAll('.bar-fill').forEach(b => b.classList.add('go'));
            barObs.unobserve(e.target);
        }
    });
}, { threshold: 0.2 });

const skillsGrid = document.getElementById('skills-grid');

if (skillsGrid) {
    barObs.observe(skillsGrid);
}

// ============================================================
// Animated counters
// ============================================================

function animCount(el, target, suffix) {
    if (!el) { return; }

    let n = 0;
    const step = Math.max(1, Math.ceil(target / 50));
    const timer = setInterval(() => {
        n = Math.min(n + step, target);
        el.textContent = n + suffix;

        if (n >= target) {
            clearInterval(timer);
        }
    }, 28);
}

const statObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            animCount(document.getElementById('stat-yrs'), 14, '+');
            animCount(document.getElementById('stat-proj'), 40, '+');
            animCount(document.getElementById('stat-pkg'), 8, '');
            statObs.unobserve(e.target);
        }
    });
}, { threshold: 0.4 });

const heroGrid = document.querySelector('#hero .grid');

if (heroGrid) {
    statObs.observe(heroGrid);
}
